import { FrontEndError } from '@pya-mms/common';
import axios from 'axios';

export const useError = () => {
  const addError = async ({ errorMessage, errorFunction, token = undefined }: FrontEndError) => {
    try {
      const url = !token ? `/error` : `/anonymous-error/${token}`;
      const response = await axios.post(url, { errorMessage, errorFunction });
      return response;
    } catch (error) {
      console.error('There was an error sending the error');
      console.error(error);
    }
  };
  return { addError };
};
